import { useAuth } from "../../context/Auth";
import styles from "./NewManager.module.css";
import TopTabBar from "../Tanolet/TopTabBar";
import { useNavigate, useParams } from "react-router-dom";
import { useCallback, useEffect, useRef, useState } from "react";
import {
  AddDesignationIcon,
  CancelIcon2,
  ManagerCameraIcon,
  NewManagerCreateIcon,
} from "../../icons/Icon";
import InputTag from "../FormComponents/InputTag";
import Selector from "./Selector";
import fetchData from "../../../APIsControll/apiControll";
import { useToast } from "../Toaster/Toaster";
import RenderWebSection from "./RenderWebSection";
import VerticalDropDown from "../FormComponents/VerticalDropDown";
import states from "../../../components/context/IndianState.json";
import Button from "../Dealers/Button";
import ManagerModal from "./ManagerModal";
import RadioButtonGroup from "../FormComponents/RadioButtonGroup";
import ToggleBtn from "../FormComponents/ToggleBtn";
import AddDesignation from "../FormComponents/AddDesignation";
import SlidingFilter from "../Dealers/SlidingFilter";
import ModalWrapper from "../layoutWrapper/ModalWrapper";
import CheckBox from "../FormComponents/CheckBox";
import { decryptData, encryptData } from "../../../Encryption/Encryption";

const NewManager = () => {
  const { mode, managerId } = useAuth();
  const { manager_Id } = useParams();
  const { show } = useToast();
  const navigate = useNavigate();

  const isEdit = Boolean(manager_Id);

  const fileInputRef = useRef(null);

  const [previewImage, setPreviewImage] = useState(
    "/assets/updatedAssets/manager_img3.png",
  );

  const [selectedRoles, setSelectedRoles] = useState([]);
  const [remainingRoles, setRemainingRoles] = useState([]);

  const [remainingWarehouses, setRemainingWarehouses] = useState([]);
  const [selectedWarehouses, setSelectedWarehouses] = useState([]);

  const [modalContent, setModalContent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [activeToggles, setActiveToggles] = useState({
    Web: false,
    App: false,
  });

  const [itemList, setItemList] = useState("");

  const [errors, setErrors] = useState({});
  // const [originalData, setOriginalData] = useState(null);

  const [managerData, setManagerData] = useState({
    managerId: managerId,
    id: manager_Id,
    name: "",
    mobile: "",
    email: "",
    profileImage: previewImage,
    designation: selectedRoles,
    loginId: "",
    password: "",
    confirmPassword: "",
    assignedDealer: { value: false, label: "No" },
    selectedState: [],
    selectedWarehouse: selectedWarehouses,
    status: "active",
    paymentManagerAuth: {
      receiptCreation: false,
      maxAmountLimit: "",
      settelCashCollection: false,
      onlyCollectCash: false,
      verifyPhotoCollection: false,
    },
    marketingManagerAuth: {
      wholeSaleAccess: false,
      retailAccess: false,
    },
    orderManagerAuth: {
      masterOrderAccess: false,
      directCollectAccess: false,
    },
    inventoryManagerAuth: {
      wareHouseAccess: "selectedWarehouse",
      priceEditAccess: false,
    },
  });
  const [dispatcher, setDispatcher] = useState();
  const [deviceList, setDeviceList] = useState([]);
  const [deviceTableKey, setDeviceTableKey] = useState(0);
  const [havePassword, setHavePassword] = useState(false);

  const formatTabText = (tab) => {
    const value = typeof tab === "string" ? tab : tab?.value;
    const label = typeof tab === "string" ? null : tab?.label;

    if (label) return label;
    if (!value) return "";

    if (value === "superadmin") return "Super Admin";
    if (value === "marketing") return "Marketing";

    const isManager = value.endsWith("manager");

    if (isManager) {
      const baseName = value.slice(0, -7);
      return `${baseName
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")} Manager`;
    }

    return value;
  };

  const getManagerData = useCallback(async () => {
    try {
      const data = await fetchData("managers/getManager", {
        managerId: managerId,
        id: manager_Id,
      });

      setManagerData((prev) => ({
        ...prev,
        profileImage: previewImage,
        name: data.data.name,
        mobile: data.data.mobile,
        email: data.data.email,
        // designation: data.data.designation,
        loginId: data.data.loginId,
        assignedDealer:
          data.data.assignedDealer === true
            ? { label: "Yes", value: true }
            : { label: "No", value: false },
        status: data.data.status,
        selectedState: data.data.selectedState.map((state) => ({
          ...state,
          value: state.stateName,
          label: state.stateName,
        })),
        selectedWarehouse: data.data.selectedWarehouse.map((w) => ({
          warehousename: w.warehousename,
        })),
        selectedDM: data.data.selectedDM
          ? data.data.selectedDM.map((dm) => ({
              dmName: dm.dmName,
              dmId: dm.dmId,
            }))
          : [],
        paymentManagerAuth: {
          receiptCreation:
            data.data.paymentManagerAuth?.receiptCreation || false,
          maxAmountLimit: data.data.paymentManagerAuth?.maxAmountLimit || "",
          settelCashCollection:
            data.data.paymentManagerAuth?.settelCashCollection || false,
          onlyCollectCash:
            data.data.paymentManagerAuth?.onlyCollectCash || false,
          verifyPhotoCollection:
            data.data.paymentManagerAuth?.verifyPhotoCollection || false,
        },
        marketingManagerAuth: {
          wholeSaleAccess:
            data.data.marketingManagerAuth?.wholeSaleAccess || false,
          retailAccess: data.data.marketingManagerAuth?.retailAccess || false,
        },

        orderManagerAuth: {
          directCollectAccess:
            data.data.orderManagerAuth?.directCollectAccess || false,
          masterOrderAccess:
            data.data.orderManagerAuth?.masterOrderAccess || false,
        },

        inventoryManagerAuth: {
          wareHouseAccess:
            data.data.inventoryManagerAuth?.wareHouseAccess ||
            "selectedWarehouse",
          priceEditAccess:
            data.data.inventoryManagerAuth?.priceEditAccess || false,
        },
      }));

      setSelectedRoles(
        data.data.designation.map((d) => ({
          label: formatTabText(d),
          value: d,
        })),
      );

      setSelectedWarehouses(
        data.data.selectedWarehouse.map((w) => ({
          label: w.warehousename,
          value: w.warehouseId || w.value,
        })),
      );
      setDeviceList(data?.data?.permissions);
      setHavePassword(data.data.password);
      if (data.data.selectedDM) {
        setDispatcher(
          data.data.selectedDM.map((obj) => ({
            label: obj.dmName,
            value: obj.dmId,
          })),
        );
      }

      // ------------------------- for Compare Data Update -------------------------------
      // setOriginalData({
      //   name: data.data.name,
      //   mobile: data.data.mobile,
      //   loginId: data.data.loginId,
      //   status: data.data.status,

      //   designation: data.data.designation.sort(),

      //   selectedState: data.data.selectedState.map((s) => s.stateName).sort(),

      //   selectedWarehouse: data.data.selectedWarehouse
      //     .map((w) => w.warehouseId)
      //     .sort(),

      //   assignedDealer: data.data.assignedDealer,
      //   profileImage: previewImage,

      //   paymentManagerAuth: {
      //     receiptCreation:
      //       data.data.paymentManagerAuth?.receiptCreation || false,
      //     maxAmountLimit: data.data.paymentManagerAuth?.maxAmountLimit || "",
      //     settelCashCollection:
      //       data.data.paymentManagerAuth?.settelCashCollection || false,
      //     onlyCollectCash:
      //       data.data.paymentManagerAuth?.onlyCollectCash || false,
      //     verifyPhotoCollection:
      //       data.data.paymentManagerAuth?.verifyPhotoCollection || false,
      //   },

      //   marketingManagerAuth: {
      //     wholeSaleAccess:
      //       data.data.marketingManagerAuth?.wholeSaleAccess || false,
      //     retailAccess: data.data.marketingManagerAuth?.retailAccess || false,
      //   },

      //   orderManagerAuth: {
      //     directCollectAccess:
      //       data.data.orderManagerAuth?.directCollectAccess || false,
      //     masterOrderAccess:
      //       data.data.orderManagerAuth?.masterOrderAccess || false,
      //   },

      //   inventoryManagerAuth: {
      //     wareHouseAccess:
      //       data.data.inventoryManagerAuth?.wareHouseAccess ||
      //       "selectedWarehouse",
      //     priceEditAccess:
      //       data.data.inventoryManagerAuth?.priceEditAccess || false,
      //   },
      // });

      // ---------------------------------------------------------------------------
    } catch (error) {
      console.error("Error fetching manager data:", error);
    }
  }, [managerId, manager_Id, previewImage]);

  useEffect(() => {
    return () => {
      setSelectedWarehouses([]);
      setRemainingWarehouses([]);
    };
  }, []);

  useEffect(() => {
    const getAllWarehouse = async () => {
      const paylod = {
        managerId,
      };
      const data = await fetchData(
        "warehouses/getAllWarehouse?limit=100",
        paylod,
      );
      const warehouses = data.data.map((item) => ({
        label: item.warehousename,
        value: item.warehouseId,
      }));

      const filteredWarehouses = warehouses.filter(
        (warehouse) =>
          !selectedWarehouses.some(
            (selected) => selected.value === warehouse.value,
          ),
      );

      setRemainingWarehouses(filteredWarehouses);
    };

    const getAllDesignations = async () => {
      const data = await fetchData("managers/getAllDesignations");
      const designations = data.data.map((item) => item.designation);
      setRemainingRoles(
        designations.map((d) => ({ label: formatTabText(d), value: d })),
      );
    };

    getAllWarehouse();
    getAllDesignations();

    if (isEdit) {
      getManagerData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getManagerData, isEdit, managerId, deviceTableKey]);

  useEffect(() => {
    if (deviceList?.length === 0) {
      setActiveToggles({
        Web: false,
        App: false,
      });
      return;
    }
    const webDevices = deviceList.filter(
      (device) => device.devicePlatform === "web",
    );
    const allWebActive =
      webDevices?.length > 0 &&
      webDevices.every(
        (device) =>
          device?.deviceActive === "pinsetup" ||
          device?.deviceActive === "active",
      );
    const appDevices = deviceList.filter(
      (device) => device.devicePlatform === "app",
    );
    const allAppActive =
      appDevices?.length > 0 &&
      appDevices.every(
        (device) =>
          device?.deviceActive === "pinsetup" ||
          device?.deviceActive === "active",
      );
    setActiveToggles({
      Web: allWebActive,
      App: allAppActive,
    });
  }, [deviceList]);

  const handleToggleWeb = async () => {
    const deviceListdata = deviceList || [];
    const paylod = {
      managerId: managerId,
      deviceIds: [],
    };
    paylod.deviceIds = deviceListdata
      .filter((device) => device?.devicePlatform === "web")
      .map((device) => device?.deviceId);

    if (activeToggles.Web) {
      setActiveToggles((pre) => ({
        ...pre,
        Web: false,
      }));
      try {
        const result = await fetchData(`managers/disabledDeviceRequest`, {
          payload: encryptData(paylod),
        });
        const res = decryptData(result?.res);
        if (res?.status === "success") {
          getManagerData();
          show(`${res?.msg}`, "success");
          setActiveToggles((pre) => ({
            ...pre,
            Web: false,
          }));
          return;
        }
        if (res?.status === "failed") {
          setActiveToggles((pre) => ({
            ...pre,
            Web: true,
          }));
          show(`${res?.msg}`, "error");
          return;
        } else {
          show("something went wrong", "error");
          setActiveToggles((pre) => ({
            ...pre,
            Web: true,
          }));
        }
      } catch (error) {
        show("something went wrong", "error");
        setActiveToggles((pre) => ({
          ...pre,
          Web: true,
        }));
      }
    } else {
      setActiveToggles((pre) => ({
        ...pre,
        Web: true,
      }));
      try {
        const result = await fetchData(`managers/accessDeviceRequest`, {
          payload: encryptData(paylod),
        });
        const res = decryptData(result?.res);
        if (res?.status === "success") {
          getManagerData();
          show(`${res?.msg}`, "success");
          setActiveToggles((pre) => ({
            ...pre,
            Web: true,
          }));
          return;
        }
        if (res?.status === "failed") {
          setActiveToggles((pre) => ({
            ...pre,
            Web: false,
          }));
          show(`${res?.msg}`, "error");
          return;
        } else {
          show("something went wrong", "error");
          setActiveToggles((pre) => ({
            ...pre,
            Web: false,
          }));
        }
      } catch (error) {
        show("something went wrong", "error");
        setActiveToggles((pre) => ({
          ...pre,
          Web: false,
        }));
      }
    }
  };

  const handleToggleApp = async () => {
    const deviceListdata = deviceList || [];
    const paylod = {
      managerId: managerId,
      deviceIds: [],
    };
    paylod.deviceIds = deviceListdata
      .filter((device) => device?.devicePlatform === "app")
      .map((device) => device?.deviceId);

    if (activeToggles.App) {
      setActiveToggles((pre) => ({
        ...pre,
        App: false,
      }));
      try {
        const result = await fetchData(`managers/disabledDeviceRequest`, {
          payload: encryptData(paylod),
        });
        const res = decryptData(result?.res);
        if (res?.status === "success") {
          getManagerData();
          show(`${res?.msg}`, "success");
          setActiveToggles((pre) => ({
            ...pre,
            App: false,
          }));
          return;
        }
        if (res?.status === "failed") {
          setActiveToggles((pre) => ({
            ...pre,
            App: true,
          }));
          show(`${res?.msg}`, "error");
          return;
        } else {
          show("something went wrong", "error");
          setActiveToggles((pre) => ({
            ...pre,
            App: true,
          }));
        }
      } catch (error) {
        show("something went wrong", "error");
        setActiveToggles((pre) => ({
          ...pre,
          App: true,
        }));
      }
    } else {
      setActiveToggles((pre) => ({
        ...pre,
        App: true,
      }));
      try {
        const result = await fetchData(`managers/accessDeviceRequest`, {
          payload: encryptData(paylod),
        });
        const res = decryptData(result?.res);
        if (res?.status === "success") {
          getManagerData();
          show(`${res?.msg}`, "success");
          setActiveToggles((pre) => ({
            ...pre,
            App: true,
          }));
          return;
        }
        if (res?.status === "failed") {
          setActiveToggles((pre) => ({
            ...pre,
            App: false,
          }));
          show(`${res?.msg}`, "error");
          return;
        } else {
          show("something went wrong", "error");
          setActiveToggles((pre) => ({
            ...pre,
            App: false,
          }));
        }
      } catch (error) {
        show("something went wrong", "error");
        setActiveToggles((pre) => ({
          ...pre,
          App: false,
        }));
      }
    }
  };

  const selectedDM =
    dispatcher &&
    dispatcher.map((item) => ({ dmName: item.value, dmId: item.key }));

  const createManager = async (data) => {
    try {
      const res = await fetchData("managers/register", data);
      if (res.status === "success") {
        navigate("/managers");
        show(res.msg, "success");
        return;
      }
      if (res.status === "failed") {
        show(res.msg, "error");
      }
    } catch (error) {
      alert(
        `Creation failed: ${error.message || "An unexpected error occurred."}`,
      );
    }
  };

  const updateManager = async (data) => {
    try {
      const res = await fetchData("managers/updateManager", data);

      if (res.status === "success") {
        navigate("/managers");
        show(res.msg, "success");
      } else {
        alert(
          `Error: ${res.msg || "An error occurred while updating the manager."}`,
        );
      }
    } catch (error) {
      alert(
        `Update failed: ${error.message || "An unexpected error occurred."}`,
      );
    }
  };

  const handleOpenModal = (content) => {
    setModalContent(content);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setModalContent(null);
  };

  const handlePhotoClick = () => {
    fileInputRef.current.click();
  };

  const handlePhotoChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setPreviewImage(imageUrl);
    }
  };

  const getRoleValue = (role) => (typeof role === "string" ? role : role.value);

  const handleRolesChange = (role) => {
    const roleValue = getRoleValue(role);
    const isRoleSelected = selectedRoles.some(
      (r) => getRoleValue(r) === roleValue,
    );

    if (roleValue === "superadmin" && isRoleSelected) {
      setSelectedRoles([]);
      setManagerData((prev) => ({
        ...prev,
        designation: [],
      }));
      setRemainingRoles((prev) => {
        const allRoles = [...prev, ...selectedRoles];
        return allRoles.filter(
          (r, i, self) =>
            i === self.findIndex((t) => getRoleValue(t) === getRoleValue(r)),
        );
      });
      return;
    }

    if (roleValue === "superadmin" && selectedRoles.length > 0) {
      setRemainingRoles((prev) => {
        const allRoles = [...prev, ...selectedRoles];
        return allRoles
          .filter((r) => getRoleValue(r) !== "superadmin")
          .filter(
            (r, i, self) =>
              i === self.findIndex((t) => getRoleValue(t) === getRoleValue(r)),
          );
      });

      setSelectedRoles([role]);
      setManagerData((prev) => ({
        ...prev,
        designation: [roleValue],
      }));
      return;
    }

    if (selectedRoles.some((r) => getRoleValue(r) === "superadmin")) {
      show("Remove Super Admin to select other role(s)!", "warning");
      return;
    }

    if (isRoleSelected) {
      const updatedRoles = selectedRoles.filter(
        (r) => getRoleValue(r) !== roleValue,
      );

      setSelectedRoles(updatedRoles);
      setManagerData((prev) => ({
        ...prev,
        designation: updatedRoles.map(getRoleValue),
      }));

      setRemainingRoles((prev) => {
        const updated = [...prev, role];
        return updated.filter(
          (r, i, self) =>
            i === self.findIndex((t) => getRoleValue(t) === getRoleValue(r)),
        );
      });
    } else {
      const updatedRoles = [...selectedRoles, role];

      setSelectedRoles(updatedRoles);
      setManagerData((prev) => ({
        ...prev,
        designation: updatedRoles.map(getRoleValue),
      }));

      setRemainingRoles((prev) =>
        prev.filter((r) => getRoleValue(r) !== roleValue),
      );
    }
  };

  const handleWarehouseChange = (warehouse) => {
    const warehouseExists = selectedWarehouses.some(
      (w) => w.value === warehouse.value,
    );

    if (warehouseExists) {
      setSelectedWarehouses((prev) =>
        prev.filter((w) => w.value !== warehouse.value),
      );
      setRemainingWarehouses((prev) =>
        [...prev, warehouse].filter(
          (w, i, self) => i === self.findIndex((t) => t.value === w.value),
        ),
      );
    } else {
      setSelectedWarehouses((prev) => [...prev, warehouse]);
      setRemainingWarehouses((prev) =>
        prev.filter((w) => w.value !== warehouse.value),
      );
    }
  };

  const handleCheckboxChange = (field) => (e) => {
    const isChecked = e.target.checked;

    setManagerData((prev) => {
      let updatedAuth = {
        ...prev.paymentManagerAuth,
        [field]: isChecked,
      };

      if (field === "verifyPhotoCollection" && isChecked) {
        updatedAuth.settelCashCollection = true;
      }

      if (field === "settelCashCollection" && !isChecked) {
        updatedAuth.verifyPhotoCollection = false;
      }

      return {
        ...prev,
        paymentManagerAuth: updatedAuth,
      };
    });
  };

  const handleOrderManagerCheckboxChange = (field) => (e) => {
    const isChecked = e.target.checked;

    setManagerData((prev) => {
      const updatedAuth = {
        ...prev.orderManagerAuth,
        [field]: isChecked,
      };

      return {
        ...prev,
        orderManagerAuth: updatedAuth,
      };
    });
  };

  const handleInvPriceCheckboxChange = (field) => (e) => {
    const isChecked = e.target.checked;

    setManagerData((prev) => {
      const updatedAuth = {
        ...prev.inventoryManagerAuth,
        [field]: isChecked,
      };

      return {
        ...prev,
        inventoryManagerAuth: updatedAuth,
      };
    });
  };

  const handleMarketingCheckboxChange = (field) => (e) => {
    const isChecked = e.target.checked;

    setManagerData((prev) => {
      const updatedAuth = {
        ...prev.marketingManagerAuth,
        [field]: isChecked,
      };

      return {
        ...prev,
        marketingManagerAuth: updatedAuth,
      };
    });
  };

  const openWebTogggle = () => {
    handleOpenModal(
      <ManagerModal
        heading={`${activeToggles.Web ? "Disabled" : "Accept"} Request`}
        centerHeading={`Are you sure you want to ${
          activeToggles.Web ? "Disabled" : "Accept"
        }  all web devices for ${managerData.name}?`}
        subHeading={`To confirm, type ${
          activeToggles.Web ? "disabled" : "accept"
        } in the text field.`}
        targetWord={activeToggles.Web ? "disabled" : "accept"}
        handleSubmit={handleToggleWeb}
        handleCloseModal={() => setIsModalOpen(false)}
        focus={true}
      />,
    );
  };

  const openAppTogggle = () => {
    handleOpenModal(
      <ManagerModal
        heading={`${activeToggles.App ? "Disabled" : "Accept"} Request`}
        centerHeading={`Are you sure you want to ${
          activeToggles.App ? "Disabled" : "Accept"
        }  all App devices for ${managerData.name}?`}
        subHeading={`To confirm, type ${
          activeToggles.App ? "disabled" : "accept"
        } in the text field.`}
        targetWord={activeToggles.App ? "disabled" : "accept"}
        handleSubmit={handleToggleApp}
        handleCloseModal={() => setIsModalOpen(false)}
        focus={true}
      />,
    );
  };

  const openUpdateManager = () => {
    const updatedManagerData = {
      ...managerData,
      managerId,
      id: manager_Id,
      selectedDM: selectedDM,
      assignedDealer: managerData.assignedDealer?.value ?? false,
      selectedState: managerData.selectedState.map((s) => ({
        stateName: s.value,
      })),
      selectedWarehouse: selectedWarehouses.map((s) => ({
        warehousename: s.label,
        warehouseId: s.value,
      })),
      designation: selectedRoles.map((r) => r.value),
    };

    const { isValid, errors } = validateManagerData(updatedManagerData);

    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }

    if (isValid) {
      handleOpenModal(
        <ManagerModal
          heading={"Update Manager"}
          centerHeading={"Are you sure you want to Update?"}
          subHeading={"To confirm! type update in the text field."}
          targetWord={"update"}
          handleSubmit={() => {
            updateManager(updatedManagerData);
          }}
          handleCloseModal={handleCloseModal}
          focus={true}
        />,
      );
    }
  };

  const openCreateManager = () => {
    const updatedManagerData = {
      ...managerData,
      selectedDM: selectedDM,
      assignedDealer: managerData.assignedDealer?.value ?? false,
      selectedState: managerData.selectedState.map((s) => ({
        stateName: s.value,
      })),
      selectedWarehouse: selectedWarehouses.map((s) => ({
        warehousename: s.label,
        warehouseId: s.value,
      })),
      designation: selectedRoles.map((r) => r.value),
    };

    const { isValid, errors } = validateManagerData(updatedManagerData);

    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }

    if (isValid) {
      handleOpenModal(
        <ManagerModal
          heading={"Create Manager"}
          centerHeading={"Are you sure you want to Create?"}
          subHeading={"To confirm! type create in the text field."}
          targetWord={"create"}
          handleSubmit={() => {
            createManager(updatedManagerData);
          }}
          handleCloseModal={handleCloseModal}
          focus={true}
        />,
      );
    }
  };

  const validateManagerData = (data) => {
    const errors = {};

    const roles = Array.isArray(data.designation)
      ? data.designation.map((r) => r.toLowerCase())
      : [];

    if (!data.name?.trim()) {
      errors.name = "Name is required.";
    }

    if (!data.mobile?.trim()) {
      errors.mobile = "Mobile number is required.";
    }
    if (!data.email?.trim()) {
      errors.email = "Email is required.";
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailRegex.test(data.email)) {
        errors.email = "Enter a valid email address.";
      }
    }

    if (!data.loginId?.trim()) {
      errors.loginId = "Login ID is required.";
    }

    // if (!data.password?.trim()) {
    //   errors.password = "Password is required.";
    // }

    // if (!data.confirmPassword?.trim()) {
    //   errors.confirmPassword = "Confirmation Password is required.";
    // }

    if (data.password?.trim() && !data.confirmPassword?.trim()) {
      errors.confirmPassword = "Confirmation Password is required.";
    }

    if (data.confirmPassword?.trim() && !data.password?.trim()) {
      errors.password = "Password is required.";
    }

    if (
      data.password &&
      data.confirmPassword &&
      data.password !== data.confirmPassword
    ) {
      errors.confirmPassword = "Passwords do not match.";
    }

    if (roles.length === 0 || selectedRoles.length === 0) {
      errors.designation = "At least one role must be selected.";
    }

    if (
      roles.includes("ordermanager") &&
      (!data.selectedState || data.selectedState.length === 0)
    ) {
      errors.selectedState =
        "At least one state must be selected for Order Manager.";
    }

    const requiresWarehouse = roles.some(
      (r) =>
        !["ordermanager", "superadmin", "contentmanager", "marketing"].includes(
          r,
        ),
    );

    if (
      requiresWarehouse &&
      (!data.selectedWarehouse || data.selectedWarehouse.length === 0)
    ) {
      errors.selectedWarehouse =
        "At least one warehouse must be selected for this role.";
    }

    if (
      roles.includes("paymentmanager") &&
      (!data.paymentManagerAuth?.maxAmountLimit ||
        data.paymentManagerAuth.maxAmountLimit === "")
    ) {
      errors.maxAmountLimit =
        "Max amount limit is required for Payment Manager.";
    }

    if (
      roles.includes("marketing") &&
      !data.marketingManagerAuth.wholeSaleAccess &&
      !data.marketingManagerAuth.retailAccess
    ) {
      errors.marketing = "One option is required!";
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors,
    };
  };

  const isOM = selectedRoles?.some((role) => role.value === "ordermanager");

  const isPM = selectedRoles?.some((role) => role.value === "paymentmanager");

  const isMarketing = selectedRoles?.some((role) => role.value === "marketing");

  const isInventory = selectedRoles?.some(
    (role) => role.value === "inventorymanager",
  );

  const InventoryWarehouseOptions = [
    { label: "Selected Warehouse", value: "selectedWarehouse" },
    { label: "All Warehouse", value: "AllWarehouse" },
  ];

  const isOther = selectedRoles?.some(
    (role) =>
      role.value !== "ordermanager" &&
      role.value !== "marketing" &&
      role.value !== "paymentmanager" &&
      role.value !== "contentmanager" &&
      role.value !== "superadmin",
  );

  const hideCashCollection =
    managerData.paymentManagerAuth.settelCashCollection ||
    managerData.paymentManagerAuth.verifyPhotoCollection;

  const hideSettleCollection = managerData.paymentManagerAuth.onlyCollectCash;

  const showCashAndSettle = !hideCashCollection && !hideSettleCollection;

  const stateOptions = states.map((state) => ({
    key: state.key,
    label: state.label,
    value: state.value,
  }));

  const radioOptions = [
    { label: "Active", value: "active" },
    { label: "Inactive", value: "disable" },
  ];

  const dealerOptions = [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ];

  const itemListData = ["Flexible", "Fixed"];

  // ------------------------- for Compare Changes ----------------------
  // const isChanged = useMemo(() => {
  //   if (!originalData) return false;

  //   const currentComparableData = {
  //     name: managerData.name,
  //     mobile: managerData.mobile,
  //     loginId: managerData.loginId,
  //     status: managerData.status,

  //     designation: selectedRoles.map((r) => r.value).sort(),

  //     selectedState: managerData.selectedState.map((s) => s.value).sort(),

  //     selectedWarehouse: selectedWarehouses.map((w) => w.value).sort(),
  //     assignedDealer: managerData.assignedDealer?.value,
  //     profileImage: managerData.profileImage,

  //     paymentManagerAuth: managerData.paymentManagerAuth,
  //     marketingManagerAuth: managerData.marketingManagerAuth,
  //     orderManagerAuth: managerData.orderManagerAuth,
  //     inventoryManagerAuth: managerData.inventoryManagerAuth,
  //   };

  //   const isPasswordChanged =
  //     managerData?.password?.trim() || managerData?.confirmPassword?.trim();

  //   return (
  //     JSON.stringify(originalData) !== JSON.stringify(currentComparableData) ||
  //     isPasswordChanged
  //   );
  // }, [originalData, managerData, selectedRoles, selectedWarehouses]);

  // -------------------------------------------------------------------------
  return (
    <div
      style={mode ? { backgroundColor: "#2C2E33", border: "none" } : {}}
      className={styles.nm}
    >
      <ModalWrapper isOpen={isModalOpen} onClose={handleCloseModal} noBtn>
        {modalContent}
      </ModalWrapper>

      <div className={styles.nm_top}>
        <div className={styles.nm_top_left}>
          <TopTabBar
            text={
              isEdit
                ? "Managers / Edit Manager / " + managerData.name
                : "Managers / New Manager"
            }
          />
        </div>
        <div>
          {isEdit && (
            <p
              className={styles.nm_top_right}
              style={{ color: mode && "#D9D9D9" }}
            >
              Last Online Status:{" "}
              <span style={{ fontSize: "12px" }}>
                Create New Manager Today at 01.00 PM 12-05-2024, Window App{" "}
                <span
                  style={{
                    color: mode ? "#749AFF" : "#0100E4",
                  }}
                >
                  History
                </span>
              </span>
            </p>
          )}
        </div>
      </div>

      <div className={styles.nm_form}>
        <div className={styles.nm_form_section}>
          <div className={styles.nm_photo} onClick={handlePhotoClick}>
            {previewImage === "/assets/updatedAssets/manager_img3.png" ? (
              <div
                className={styles.manager_photo_text}
                style={{
                  color: mode ? "#ffffff" : "#000000",
                }}
              >
                {managerData?.name?.charAt(0).toUpperCase() || (
                  <img src={previewImage} alt="Manager" />
                )}
              </div>
            ) : null}
            <div className={styles.nm_camera_icon}>
              <ManagerCameraIcon />
            </div>
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handlePhotoChange}
              accept="image/*"
            />
          </div>

          <div
            className={`${styles.inp_con} ${mode ? styles.inp_con_dark : ""}`}
          >
            <div className={styles.element}>
              <InputTag
                name="name"
                value={managerData.name}
                labelText={"Name"}
                placeholderText={"Enter name"}
                placeholderType={"text"}
                required={true}
                star
                maxLength={50}
                onChange={(e) => {
                  setManagerData((prev) => ({
                    ...prev,
                    name: e.target.value,
                  }));
                }}
                padding={"8px"}
                fontSize={"12px"}
              />
              {errors.name && <span>{errors.name}</span>}
            </div>
            <div className={styles.element}>
              <InputTag
                name="mobile"
                value={managerData.mobile}
                labelText={"Mobile Number"}
                placeholderText={"Enter mobile number"}
                placeholderType={"number"}
                required={true}
                star
                maxLength={10}
                onChange={(e) => {
                  setManagerData((prev) => ({
                    ...prev,
                    mobile: e.target.value,
                  }));
                }}
                padding={"8px"}
                fontSize={"12px"}
              />
              {errors.mobile && <span>{errors.mobile}</span>}
            </div>

            <div className={styles.element}>
              <InputTag
                name="email"
                value={managerData.email}
                labelText={"Email"}
                placeholderText={"Enter email"}
                placeholderType={"email"}
                required={true}
                maxLength={50}
                onChange={(e) => {
                  setManagerData((prev) => ({
                    ...prev,
                    email: e.target.value,
                  }));
                }}
                star
                padding={"8px"}
                fontSize={"12px"}
              />
              {errors.email && (
                <span className={styles.error}>{errors.email}</span>
              )}
            </div>

            <div>
              <InputTag
                labelText={"Attendance"}
                placeholderType={"number"}
                placeholderText={"Coming Soon"}
                required={true}
                disabled
                padding={"8px"}
                fontSize={"12px"}
              />
            </div>
          </div>

          <div className={styles.element}>
            <Selector
              mode={mode}
              header={"Assign Role"}
              selected={selectedRoles}
              remaining={remainingRoles}
              handleChange={handleRolesChange}
            />
            {errors.designation && <span>{errors.designation}</span>}
          </div>
        </div>

        <div className={`${styles.nm_form_section}`}>
          <RenderWebSection
            setManagerData={setManagerData}
            managerData={managerData}
            isEdit={isEdit}
            deviceList={deviceList}
            deviceTableKey={deviceTableKey}
            setDeviceTableKey={setDeviceTableKey}
            havePassword={havePassword}
            errors={errors}
          />

          {(isOM || isMarketing) && (
            <div
              className={`${styles.nm_order_manager} ${styles.inp_con} ${
                mode ? styles.inp_con_dark : ""
              }`}
            >
              {isOM && (
                <div className={styles.marketing}>
                  <div className={styles.element_2}>
                    <div className={styles.checkbox_sec}>
                      <p style={{ color: mode && "#ffffff" }}>
                        Direct Collect Access
                      </p>

                      <CheckBox
                        checked={
                          managerData.orderManagerAuth.directCollectAccess ||
                          false
                        }
                        handleChange={handleOrderManagerCheckboxChange(
                          "directCollectAccess",
                        )}
                      />
                    </div>
                    {errors.orderCreateAccess && (
                      <span>{errors.orderCreateAccess}</span>
                    )}
                  </div>

                  <div className={styles.element_2}>
                    <div className={styles.checkbox_sec}>
                      <p style={{ color: mode && "#ffffff" }}>
                        Master Order Access
                      </p>

                      <CheckBox
                        checked={
                          managerData.orderManagerAuth.masterOrderAccess ||
                          false
                        }
                        handleChange={handleOrderManagerCheckboxChange(
                          "masterOrderAccess",
                        )}
                      />
                    </div>
                    {errors.orderCreateAccess && (
                      <span>{errors.orderCreateAccess}</span>
                    )}
                  </div>
                </div>
              )}

              {isOM && (
                <VerticalDropDown
                  options={dealerOptions}
                  label={"Assigned Dealer"}
                  star
                  dropDownText={"Select"}
                  value={managerData.assignedDealer}
                  onchange={(v) =>
                    setManagerData((prev) => ({
                      ...prev,
                      assignedDealer: v,
                    }))
                  }
                  height={"37px"}
                  fontSize={"12px"}
                />
              )}

              {isMarketing && (
                <div className={styles.marketing}>
                  <div className={styles.element_2}>
                    <div className={styles.checkbox_sec}>
                      <p style={{ color: mode && "#ffffff" }}>Retail Access</p>

                      <CheckBox
                        checked={
                          managerData.marketingManagerAuth.retailAccess || false
                        }
                        handleChange={handleMarketingCheckboxChange(
                          "retailAccess",
                        )}
                      />
                    </div>
                    {errors.marketing && <span>{errors.marketing}</span>}
                  </div>

                  <div className={styles.element_2}>
                    <div className={styles.checkbox_sec}>
                      <p style={{ color: mode && "#ffffff" }}>
                        Wholesale Access
                      </p>

                      <CheckBox
                        checked={
                          managerData.marketingManagerAuth.wholeSaleAccess ||
                          false
                        }
                        handleChange={handleMarketingCheckboxChange(
                          "wholeSaleAccess",
                        )}
                      />
                    </div>
                    {errors.marketing && <span>{errors.marketing}</span>}
                  </div>
                </div>
              )}

              <div className={styles.element}>
                <VerticalDropDown
                  options={stateOptions}
                  label={"Assigned State"}
                  star
                  dropDownText={"Select"}
                  value={managerData.selectedState}
                  onchange={(v) =>
                    setManagerData((prev) => ({
                      ...prev,
                      selectedState: v,
                    }))
                  }
                  multiple={true}
                  height={"37px"}
                  fontSize={"12px"}
                />{" "}
                {errors.selectedState && <span>{errors.selectedState}</span>}
              </div>
            </div>
          )}

          {isInventory && (
            <div
              className={`${styles.nm_order_manager} ${styles.inp_con} ${
                mode ? styles.inp_con_dark : ""
              }`}
            >
              <div className={styles.marketing}>
                <div>
                  <div className={styles.checkbox_sec}>
                    <p style={{ color: mode && "#ffffff" }}>
                      Warehouse Access
                      <span style={{ color: "#F93E3E" }}>*</span>
                    </p>
                    <RadioButtonGroup
                      key={managerData.inventoryManagerAuth?.wareHouseAccess}
                      options={InventoryWarehouseOptions}
                      selectedOption={
                        managerData.inventoryManagerAuth?.wareHouseAccess
                      }
                      onChange={(s) =>
                        setManagerData((prev) => ({
                          ...prev,
                          inventoryManagerAuth: {
                            wareHouseAccess: s,
                            priceEditAccess:
                              managerData.inventoryManagerAuth
                                .priceEditAccess || false,
                          },
                        }))
                      }
                    />
                  </div>
                </div>

                <div className={styles.element_2}>
                  <div className={styles.checkbox_sec}>
                    <p style={{ color: mode && "#ffffff" }}>
                      Price Edit Access
                    </p>

                    <CheckBox
                      checked={
                        managerData.inventoryManagerAuth.priceEditAccess ||
                        false
                      }
                      handleChange={handleInvPriceCheckboxChange(
                        "priceEditAccess",
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          {isPM && (
            <div
              className={`${styles.nm_order_manager} ${styles.inp_con} ${
                mode ? styles.inp_con_dark : ""
              }`}
            >
              <p style={{ color: mode && "#ffffff", marginBottom: "-0.5rem" }}>
                Payment Manager
                <div className={styles.element} style={{ marginTop: "10px" }}>
                  <InputTag
                    name="maxAmountLimit"
                    value={managerData.paymentManagerAuth.maxAmountLimit}
                    labelText={"Max Receipt Amount"}
                    placeholderText={"Enter Max Receipt Amount"}
                    placeholderType={"number"}
                    star
                    maxLength={15}
                    onChange={(e) => {
                      setManagerData((prev) => ({
                        ...prev,
                        paymentManagerAuth: {
                          ...prev.paymentManagerAuth,
                          maxAmountLimit: e.target.value,
                        },
                      }));
                    }}
                    padding={"8px"}
                    fontSize={"12px"}
                  />
                  {errors.maxAmountLimit && (
                    <span>{errors.maxAmountLimit}</span>
                  )}
                </div>
                <div className={styles.checkbox_sec}>
                  <p style={{ color: mode && "#ffffff" }}>Create Receipt</p>

                  <CheckBox
                    checked={
                      managerData.paymentManagerAuth.receiptCreation || false
                    }
                    handleChange={handleCheckboxChange("receiptCreation")}
                  />
                </div>
                <div>
                  {showCashAndSettle && (
                    <>
                      <div className={styles.checkbox_sec}>
                        <p style={{ color: mode && "#ffffff" }}>
                          Settle Collection
                        </p>

                        <CheckBox
                          checked={
                            managerData.paymentManagerAuth
                              .settelCashCollection || false
                          }
                          handleChange={handleCheckboxChange(
                            "settelCashCollection",
                          )}
                        />
                      </div>
                      <div className={styles.checkbox_sec}>
                        <p style={{ color: mode && "#ffffff" }}>
                          Photo Verification
                        </p>

                        <CheckBox
                          checked={
                            managerData.paymentManagerAuth
                              .verifyPhotoCollection || false
                          }
                          handleChange={handleCheckboxChange(
                            "verifyPhotoCollection",
                          )}
                        />
                      </div>
                      <div className={styles.checkbox_sec}>
                        <p style={{ color: mode && "#ffffff" }}>
                          Cash Collection Only
                        </p>

                        <CheckBox
                          checked={
                            managerData.paymentManagerAuth.onlyCollectCash ||
                            false
                          }
                          handleChange={handleCheckboxChange("onlyCollectCash")}
                        />
                      </div>
                    </>
                  )}

                  {!showCashAndSettle && (
                    <>
                      {hideCashCollection && (
                        <>
                          <div className={styles.checkbox_sec}>
                            <p style={{ color: mode && "#ffffff" }}>
                              Settle Collection
                            </p>

                            <CheckBox
                              checked={
                                managerData.paymentManagerAuth
                                  .settelCashCollection || false
                              }
                              handleChange={handleCheckboxChange(
                                "settelCashCollection",
                              )}
                            />
                          </div>
                          <div className={styles.checkbox_sec}>
                            <p style={{ color: mode && "#ffffff" }}>
                              Photo Verification
                            </p>

                            <CheckBox
                              checked={
                                managerData.paymentManagerAuth
                                  .verifyPhotoCollection || false
                              }
                              handleChange={handleCheckboxChange(
                                "verifyPhotoCollection",
                              )}
                            />
                          </div>
                        </>
                      )}

                      {hideSettleCollection && (
                        <div className={styles.checkbox_sec}>
                          <p style={{ color: mode && "#ffffff" }}>
                            Cash Collection Only
                          </p>

                          <CheckBox
                            checked={
                              managerData.paymentManagerAuth.onlyCollectCash ||
                              false
                            }
                            handleChange={handleCheckboxChange(
                              "onlyCollectCash",
                            )}
                          />
                        </div>
                      )}
                    </>
                  )}
                </div>
              </p>
            </div>
          )}

          {(isOther || isPM) && (
            <div className={styles.element}>
              <Selector
                mode={mode}
                header={"Assign Warehouse"}
                selected={selectedWarehouses}
                remaining={remainingWarehouses}
                handleChange={handleWarehouseChange}
              />
              {errors.selectedWarehouse && (
                <span>{errors.selectedWarehouse}</span>
              )}
            </div>
          )}
        </div>
      </div>

      <div
        className={`${styles.nm_footer} ${mode ? styles.nm_footer_dark : ""}`}
      >
        <div className={styles.nm_footer_1}>
          <div>
            <div className={styles.radio_section}>
              <p
                style={{
                  color: mode ? "#9C9797" : "#646B88",
                  margin: "0",
                }}
              >
                Status<span style={{ color: "#F93E3E" }}>*</span>
              </p>
              <RadioButtonGroup
                key={managerData.status}
                options={radioOptions}
                selectedOption={managerData.status}
                onChange={(s) =>
                  setManagerData((prev) => ({
                    ...prev,
                    status: s,
                  }))
                }
              />
            </div>
          </div>

          <div>
            <p
              style={{
                color: mode ? "#9C9797" : "#646B88",
              }}
            >
              Platform Access<span style={{ color: "#F93E3E" }}>*</span>
            </p>
            <div className={styles.toggle_section}>
              <ToggleBtn
                status={activeToggles.Web ? "active" : ""}
                placeholder={"Web"}
                onClick={() => openWebTogggle()}
              />
              <ToggleBtn
                status={activeToggles.App ? "active" : ""}
                placeholder={"App"}
                onClick={() => openAppTogggle()}
              />
            </div>
          </div>

          <div>
            <p
              style={{
                color: mode ? "#9C9797" : "#646B88",
              }}
            >
              Work Status<span style={{ color: "#F93E3E" }}>*</span>
            </p>
            <ToggleBtn labelText="Work Status" status={""} />
          </div>
          <SlidingFilter
            itemList={itemListData}
            setFilter={setItemList}
            bgcolor={"#4164E3"}
          />
        </div>

        <div className={styles.nm_footer_2}>
          {!isEdit && (
            <>
              <Button
                buttonIcon={<AddDesignationIcon />}
                buttonText={"Designation"}
                buttonBgColor={"transparent"}
                buttonTextColor={"#4164E3"}
                buttonBorder={"1px solid #4164E3"}
                buttonClick={() => {
                  handleOpenModal(
                    <AddDesignation handleCloseModal={handleCloseModal} />,
                  );
                }}
              />
            </>
          )}
          <Button
            buttonIcon={<CancelIcon2 />}
            buttonText={"CANCEL"}
            buttonBgColor={"#000000"}
            buttonTextColor={"#ffffff"}
            buttonBorder={"none"}
            buttonClick={() => navigate(-1)}
          />
          {isEdit ? (
            <Button
              buttonIcon={<NewManagerCreateIcon />}
              buttonText={"Update"}
              buttonBgColor={"#4164E3"}
              buttonTextColor={"#ffffff"}
              buttonBorder={"none"}
              buttonClick={() => openUpdateManager()}
              // disabled={!isChanged}
            />
          ) : (
            <Button
              buttonIcon={<NewManagerCreateIcon />}
              buttonText={"Create"}
              buttonBgColor={"#4164E3"}
              buttonTextColor={"#ffffff"}
              buttonBorder={"none"}
              buttonClick={() => openCreateManager()}
            />
          )}
        </div>
      </div>

      <div
        className={styles.nm_footer_mob}
        style={mode ? { backgroundColor: "#2C2E33" } : {}}
      >
        {isEdit ? (
          <Button
            buttonIcon={<NewManagerCreateIcon />}
            buttonText={"Update"}
            buttonBgColor={"#4164E3"}
            buttonTextColor={"#ffffff"}
            buttonBorder={"none"}
            buttonClick={() => openUpdateManager()}
          />
        ) : (
          <Button
            buttonIcon={<NewManagerCreateIcon />}
            buttonText={"Create"}
            buttonBgColor={"#4164E3"}
            buttonTextColor={"#ffffff"}
            buttonBorder={"none"}
            buttonClick={() => openCreateManager()}
          />
        )}
        <Button
          buttonIcon={<CancelIcon2 />}
          buttonText={"CANCEL"}
          buttonBgColor={"#000000"}
          buttonTextColor={"#ffffff"}
          buttonBorder={"none"}
          buttonClick={() => navigate(-1)}
        />
      </div>
    </div>
  );
};

export default NewManager;
